import cx from 'classnames';
import { IInputProps } from '../input';
import styles from '../input.module.scss';

type IProps = Pick<IInputProps, 'variant' | 'scale' | 'className' | 'disabled'>;

export const getInputClassName = ({
  variant,
  scale,
  className,
  disabled,
}: IProps) => {
  const classNameVariant = `input--${variant}`;

  return cx(
    styles.input,
    styles[classNameVariant],
    styles[`scale--${scale}`],
    disabled && styles.disabled,
    variant === 'error' && styles.error,
    variant === 'success' && styles.success,
    className
  );
};
